import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLines } from "./motion";

export default function PageHero({ eyebrow, title, lines, subtitle, image, children, compact = false, testid = "page-hero" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.05, 1.18]);
  return (
    <section ref={ref} data-testid={testid} className={`grain relative flex overflow-hidden bg-navy text-ivory ${compact ? "min-h-[56vh]" : "min-h-[78vh] md:min-h-[86vh]"} items-end`}>
      {image && (
        <motion.div style={{ y, scale }} className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover" fetchpriority="high" />
        </motion.div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/60 to-navy/30" />
      <div className="container-lux relative z-10 pb-16 pt-40 md:pb-24">
        {eyebrow && <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.1 }} className="eyebrow-light">{eyebrow}</motion.p>}
        <h1 className="h-display mt-6 max-w-5xl text-5xl sm:text-6xl lg:text-[5.5rem]">
          <MaskedLines lines={lines || [title]} />
        </h1>
        {subtitle && (
          <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.7 }} className="mt-8 max-w-2xl text-base leading-relaxed text-ivory/85 md:text-lg">{subtitle}</motion.p>
        )}
        {children && <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.9 }} className="mt-10">{children}</motion.div>}
      </div>
    </section>
  );
}
